import { Module } from '../../ts/Module';
import {
  ISiteSettingsForServerAdminFormScope,
  SiteSettingsForServerAdminFormCtrl,
} from '../controllers/SiteSettingsForServerAdminFormCtrl';

Module.instance().directive('tbSiteSettingsForServerAdminForm',
  () => {
    return {
      restrict: 'E',
      replace: true,
      require: '^?tbSettingsCoordinator',
      templateUrl: 'siteSettingsForServerAdminForm.html',
      link: ($scope: ISiteSettingsForServerAdminFormScope,
        elm: JQuery,
        attrs: ng.IAttributes) => {
        $scope.localForm.formController =  $scope.siteSettingsForServerAdminForm;
        $scope.sharedForm.registerFormStateByName($scope.localForm, 'siteSettingsForServerAdminForm');
      },
      controller: SiteSettingsForServerAdminFormCtrl
    };
  }
);
